import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Ban, Archive } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const CancelledBanner = ({ order }) => (
  <div className="rounded-xl border border-red-500/40 bg-red-500/10 p-3" data-testid="cancelled-banner">
    <p className="text-red-400 font-bold text-sm flex items-center gap-2"><Ban size={16} /> BON ANNULÉ — conservé en archive</p>
    <p className="text-xs text-slate-300 mt-1" data-testid="cancelled-reason">Raison : {order.cancel_reason}</p>
    <p className="text-[11px] text-slate-500 mt-0.5">
      Par {order.cancelled_by_name || '—'} le {(order.cancelled_at || '').replace('T', ' ').slice(0, 16)}
    </p>
  </div>
);

export const CancelWorkOrderDialog = ({ orderId, orderNumber, token, onClose, onCancelled }) => {
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const res = await axios.post(`${API_URL}/api/mechanic/work-orders/${orderId}/cancel`, { reason },
        { headers: { Authorization: `Bearer ${token}` } });
      toast.success('Bon annulé et conservé en archive');
      onCancelled(res.data);
    } catch (err) { toast.error(err.response?.data?.detail || 'Erreur'); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 bg-black/70 z-50 flex items-end sm:items-center justify-center" onClick={onClose}>
      <div className="bg-slate-900 border border-slate-700 w-full max-w-md rounded-t-2xl sm:rounded-2xl p-4 space-y-3" onClick={e => e.stopPropagation()} data-testid="cancel-order-dialog">
        <p className="text-white font-semibold flex items-center gap-2"><Ban size={18} className="text-red-400" /> Annuler le bon {orderNumber}</p>
        <p className="text-xs text-slate-400 flex gap-2">
          <Archive size={14} className="shrink-0 mt-0.5" />
          Le bon ne sera pas supprimé : il reste dans l'historique du véhicule avec la mention ANNULÉ (exigence de conservation SAAQ).
        </p>
        <textarea value={reason} onChange={e => setReason(e.target.value)} rows={3} placeholder="Raison de l'annulation (obligatoire)"
          className="w-full bg-slate-800 border border-slate-700 rounded-xl p-3 text-sm text-white" data-testid="cancel-reason-input" />
        <div className="flex gap-2">
          <button onClick={onClose} className="flex-1 py-2.5 rounded-xl bg-slate-800 text-slate-300 text-sm" data-testid="cancel-dialog-close">Retour</button>
          <button onClick={submit} disabled={busy || reason.trim().length < 3}
            className="flex-1 py-2.5 rounded-xl bg-red-600 text-white font-semibold text-sm disabled:opacity-40" data-testid="cancel-confirm-btn">
            {busy ? 'Annulation…' : 'Confirmer l\u2019annulation'}
          </button>
        </div>
      </div>
    </div>
  );
};
